import axios from "@/index";
const marketingEnd = {
  state: {
    marketingEndList: [],
    marketingTimeList: [],
    marketingTimeAndAreaList: []
  },
  getters: {},
  actions: {
    getEndApplicationList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setEndApplicationList",
                (state, { marketingEndList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getMarketingTimeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setMarketingTimeList",
                (state, { marketingTimeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getTimeAndAreaInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setTimeAndAreaInfo",
                (state, { marketingTimeAndAreaList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setEndApplicationList(state, action) {
      state.marketingEndList = action.marketingEndList;
    },
    setMarketingTimeList(state, action) {
      state.marketingTimeList = action.marketingTimeList;
    },
    setTimeAndAreaInfo(state, action) {
      state.marketingTimeAndAreaList = action.marketingTimeAndAreaList;
    }
  }
};
export default marketingEnd;
